module.exports = __webpack_public_path__ + "img/logo.267d3eb7.svg";